"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_PORTRAIT_VARIANT = exports.DEFAULT_ICON_VARIANT = exports.PORTRAIT_VARIANTS = exports.ICON_VARIANTS = void 0;
exports.isIconVariant = isIconVariant;
exports.isPortraitVariant = isPortraitVariant;
exports.ICON_VARIANTS = ['small', 'large'];
exports.PORTRAIT_VARIANTS = ['thumbnail', 'card', 'large'];
exports.DEFAULT_ICON_VARIANT = 'small';
exports.DEFAULT_PORTRAIT_VARIANT = 'card';
function isIconVariant(value) {
    return exports.ICON_VARIANTS.includes(value);
}
function isPortraitVariant(value) {
    return exports.PORTRAIT_VARIANTS.includes(value);
}
//# sourceMappingURL=rich-text.js.map